import { replaceToUpperCase } from 'shared/modules';
import { getTitleOrEmpty } from 'shared/helpers/common';
import COUNTRIES from 'shared/constants/json/countries.json';

const AB_PATH = 'https://avtobazar.ua';

export const getVehicleMicroMarkingJson = advertInfo => {
  const {
    title,
    make,
    year,
    model,
    permalink,
    body,
    price,
    description,
    color,
    engine,
    gearbox,
    mileage,
    active,
    sold,
    transport,
  } = advertInfo;

  const discontinued = active === -2 || !active;
  let availabilityKey = 'InStock';

  if (sold) availabilityKey = 'SoldOut';
  else if (discontinued) availabilityKey = 'Discontinued';

  const { model_class: modelClass = null } = model;
  const modelTitle = `${getTitleOrEmpty(model)} ${getTitleOrEmpty(modelClass)}`;
  const usdPrice = price.find(item => item.currency === 'usd').value || '';

  const MAIN_TYPES = {
    avto: 'Car',
    mototsikl: 'Motorcycle',
    moped: 'MotorizedBicycle',
    skuter: 'MotorizedBicycle',
  };

  return {
    '@context': 'https://schema.org/',
    '@type': MAIN_TYPES[transport.slug] || 'Vehicle',
    name: title,
    model: modelTitle,
    productionDate: year,
    description,
    color: getTitleOrEmpty(color),
    fuelType: getTitleOrEmpty(engine),
    vehicleTransmission: getTitleOrEmpty(gearbox),
    bodyType: getTitleOrEmpty(body),
    mileageFromOdometer: {
      '@type': 'QuantitativeValue',
      value: mileage && `${mileage} 000`,
    },
    brand: {
      '@type': 'Brand',
      name: getTitleOrEmpty(make),
    },
    offers: {
      '@type': 'Offer',
      name: title,
      url: `${AB_PATH}${permalink}`,
      priceCurrency: 'USD',
      price: usdPrice,
      availability: `http://schema.org/${availabilityKey}`,
    },
  };
};

export const getProductMicroMarkingJson = advertInfo => {
  const { make, model, permalink, price, title } = advertInfo;
  const { model_class: modelClass = null } = model;

  const modelTitle = `${getTitleOrEmpty(model)} ${getTitleOrEmpty(modelClass)}`;
  const usdPrice = price.find(item => item.currency === 'usd').value || '';

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: modelTitle.replace(/\s/g, '') ? modelTitle : title,
    description: '',
    brand: {
      '@type': 'Thing',
      name: getTitleOrEmpty(make),
    },
    offers: {
      '@type': 'Offer',
      url: `${AB_PATH}${permalink}`,
      priceCurrency: 'USD',
      price: usdPrice,
    },
  };
};

export const getBreadcrumbsListData = (searchData, breadcrumbLinks) => {
  const paramArr = ['transport', 'make', 'model', 'year', 'location'];

  const breadcrumbItemListEl = paramArr.map((itemName, index) => {
    if (breadcrumbLinks[itemName]) {
      const name = itemName === 'year' ? searchData[itemName] : searchData[itemName].title;
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': breadcrumbLinks[itemName],
          name: index === 0 ? replaceToUpperCase(name) : name,
        },
      };
    }
    return false;
  });

  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItemListEl,
  };
};

export const getPrice = (prices, currenncy = ['uah', 'uah', 'грн', 'грн.']) => {
  const price = ((Array.isArray(prices) && prices) || []).find(p => currenncy.includes(p.currency));
  return price && price.value;
};

export const isTop = advert => advert && advert.top_date && new Date() < new Date(advert.top_date);
export const isVIP = advert => advert && advert.vip_date && new Date() < new Date(advert.vip_date);

export const getDrivenFromTitle = (drivenFrom, t) => {
  let drivenFromCoutry = null;
  if (drivenFrom && drivenFrom.id)
    drivenFromCoutry = COUNTRIES.find(country => country.id === drivenFrom.id);

  return drivenFromCoutry && `${t('пригнан')} ${drivenFromCoutry.from[t('locale')]}`;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/advert.js